import { useProduct } from '@modules/product';
import { useBrand } from './useBrand';

export function useProductType() {
  const { productData: product } = useProduct();
  const { isBcom } = useBrand();

  const isGiftCard = !!product?.detail?.flags?.giftCard;
  const isConsolidated3rdVariant = !!product?.detail?.flags?.isConsolidatedThirdVariant;
  const isMaster = !!product?.detail?.flags?.masterProduct;
  const isGiftWithPurchase = isBcom ? ['GWP', 'PWP'].includes(product?.detail?.typeName?.trim()?.toUpperCase()) : !!product?.detail?.flags?.gwpExperienceEnabled;
  const { upcs = {}, memberProductMap = {} } = product?.relationships || {};
  // Temp solution to fix INC3565898
  const isUnavailable = !product?.availability?.available || (!Object.keys(upcs).length && !Object.keys(memberProductMap).length);

  const isLatchKey = !isConsolidated3rdVariant && (product?.detail?.orderedMasterGroupList || [])?.length > 1;
  const isConsolidatedStandard = !!product?.detail?.flags?.consolidatedProductComplex || isConsolidated3rdVariant; // mcom only
  const isConsolidatedMaster = !!product?.detail?.flags?.consolidatedMaster && !isLatchKey && !isConsolidated3rdVariant; // bcom only
  const isConsolidatedLatchKey = (!!product?.detail?.flags?.consolidatedMaster && isLatchKey) && !isConsolidated3rdVariant;
  const isConsolidatedPage = isConsolidatedStandard || isConsolidatedMaster || isConsolidatedLatchKey;

  /** @type {ProductType} */
  const type = (function getType() {
    if (isUnavailable) return 'unavailable';
    if (isGiftCard) return 'giftCard';
    if (isMaster) return 'master';
    if (isGiftWithPurchase) return 'giftWithPurchase';
    if (isConsolidatedLatchKey) return 'consolidatedLatchKey';
    if (isLatchKey) return 'latchKey'; // bcom only TODO is this ever returned?
    if (isConsolidatedStandard) return 'consolidatedStandard'; // mcom only
    if (isConsolidatedMaster) return 'consolidatedMaster'; // bcom only
    return 'standard';
  }());

  return {
    isGiftCard,
    isMaster,
    isGiftWithPurchase,
    isUnavailable,
    isLatchKey,
    isConsolidatedMaster,
    isConsolidatedStandard,
    isConsolidatedPage,
    isConsolidatedLatchKey,
    type,
  };
}

export default useProductType;
